<template>
  <slot />
</template>
<script setup lang="ts">
import { provide } from 'vue';
import { Modal } from './modal';
import { modalKey } from './modal-key';

const props = defineProps<{ modal: Modal }>();
provide(modalKey, props.modal);
</script>
